module.exports = __webpack_public_path__ + "img/img_20yuan@2x.89cfb594.png";